/****************************************************************************************
 * File Name    : ToolWorkReport.vue
 * Function     : 치공구외 일지관리 (완료된 일지 관리)
 * Author       : 
 * Description  : 치공구 점검 일지 보고서 관리
 * Modification Log
 * ======================================================================================
 * Ver  Date        	Author     	Modification
 * ======================================================================================
   1.0  2026.02.17  	        	Create
****************************************************************************************/
<template>
    <div>
        <a-row :gutter="16">
            <a-col class="gutter-row" :span="12">
                <div class="gutter-box">
                    <PageHeader title="치공구 점검 일지 관리" />
                </div>
            </a-col>
        </a-row>
        <a-divider type='horizontal' />
        
        <a-form class="" layout="vertical">
            <a-card>
                <a-space align="end">
                    <a-input default-value="" v-model="filterCS">
                        <a-select slot="addonAfter" default-value="라인명" v-model="filterField">
                            <a-select-option value="라인명">라인명</a-select-option>
                            <a-select-option value="생산모델">생산모델</a-select-option>
                            <a-select-option value="작성자">작성자</a-select-option>
                        </a-select>
                    </a-input>

                    <span style="display: inline-block; margin-bottom: 5px; margin-left: 10px;">일자</span>
                    <date-picker v-model="filterDateStartCS" valueType="format" style="width:120px;"></date-picker>
                    <span style="display: inline-block; margin-bottom: 5px;">~</span>
                    <date-picker v-model="filterDateEndCS" valueType="format" style="width:120px;"></date-picker>
                    
                    <a-button type="primary" :ghost="true" @click="filterCSList">검색</a-button>
                    <a-button @click="resetCSList">초기화</a-button>
                </a-space>
                <p/>
                <div style="position:relative;">
                    <img id="loading-data" class="more-btn" src="../assets/images/Loading_2.gif" v-if="isLoading" style="position:absolute; top:50%; left:50%; margin-top:-30px; margin-left:-30px; width:60px; z-index:10;" />
                    <a-table :columns="columns" size="small" :bordered="false" :data-source="data" :pagination="pagination" :scroll="{ x: 0, y: '80vh' }" @change="handleTableChange">
                        <span slot="tags" slot-scope="tags">
                            <a-tag v-for="tag in tags" :key="tag" class="state-btn" :class="{ green: (tag === '작성완료'), navy: (tag === '승인완료') }">
                                {{ tag.toUpperCase() }}
                            </a-tag>
                        </span>
                        <span slot="name" slot-scope="text">{{ text }}</span>
                        <span slot="checkResult" slot-scope="text">
                            <a-tag :color="text === 'OK' ? 'green' : 'red'">
                                {{ text }}
                            </a-tag>
                        </span>
                        <span slot="action" slot-scope="record">
                            <span style='cursor:pointer' @click="handlerToView(record.key)"><a-icon type="eye" /> View</span>
                            <a-divider type="vertical" />
                            <span style='cursor:pointer' @click="handlerToApprove(record.key)" v-if="record.tags[0] === '작성완료'"><a-icon type="check-circle" /> 승인</span>
                            <span style='cursor:pointer' @click="handlerToCancelApprove(record.key)" v-if="record.tags[0] === '승인완료'"><a-icon type="close-circle" /> 승인취소</span>
                            <a-divider type="vertical" />
                            <span style='cursor:pointer' @click="handlerToDelete(record.key)"><a-icon type="delete" /> Delete</span>
                        </span>
                    </a-table>
                </div>
            </a-card>
        </a-form>

        <!-- 일지 상세보기 Drawer -->
        <a-drawer 
            title="치공구 점검 일지 상세보기" 
            placement="right" 
            :closable="true" 
            :visible="flagForDrawer" 
            @close="handlerForCloseDrawer" 
            width="100%"
        >
            <a-form layout="vertical">
                <div id="print">
                <!-- 기본정보 -->
                <a-card title="기본정보" :bordered="false" style="margin-bottom: 16px;">
                    <a-descriptions bordered :column="2">
                        <a-descriptions-item label="라인명">{{ viewData.basicInfo.lineName }}</a-descriptions-item>
                        <a-descriptions-item label="작성자명">{{ viewData.basicInfo.writer }}</a-descriptions-item>
                        <a-descriptions-item label="생산모델">{{ viewData.basicInfo.productModel }}</a-descriptions-item>
                        <a-descriptions-item label="승인자명">{{ viewData.basicInfo.approverName || '-' }}</a-descriptions-item>
                        <a-descriptions-item label="승인일자">{{ viewData.basicInfo.approvalDate || '-' }}</a-descriptions-item>
                    </a-descriptions>
                </a-card>

                <!-- 드라이버 토크 관리 -->
                <a-card title="드라이버 토크 관리" :bordered="false" style="margin-bottom: 16px;">
                    <a-table 
                        :columns="driverTorqueViewColumns" 
                        :data-source="viewData.driverTorque" 
                        :pagination="false"
                        size="small"
                        bordered
                    >
                        <template slot="no" slot-scope="text, record, index">
                            {{ index + 1 }}
                        </template>
                        <template slot="result" slot-scope="text">
                            <a-tag :color="text === 'OK' ? 'green' : 'red'">{{ text }}</a-tag>
                        </template>
                    </a-table>
                </a-card>

                <!-- 계측기 관리 -->
                <a-card title="계측기 관리" :bordered="false" style="margin-bottom: 16px;">
                    <a-table 
                        :columns="measurementViewColumns" 
                        :data-source="viewData.measurement" 
                        :pagination="false"
                        size="small"
                        bordered
                    >
                        <template slot="no" slot-scope="text, record, index">
                            {{ index + 1 }}
                        </template>
                        <template slot="result" slot-scope="text">
                            <a-tag :color="text === 'OK' ? 'green' : (text === 'NG' ? 'red' : 'blue')">{{ text }}</a-tag>
                        </template>
                    </a-table>
                </a-card>

                <!-- 가스세이버 관리 -->
                <a-card title="가스세이버 관리" :bordered="false" style="margin-bottom: 16px;">
                    <a-table 
                        :columns="gasSaverViewColumns" 
                        :data-source="viewData.gasSaver" 
                        :pagination="false"
                        size="small"
                        bordered
                    >
                        <template slot="no" slot-scope="text, record, index">
                            {{ index + 1 }}
                        </template>
                        <template slot="result" slot-scope="text">
                            <a-tag :color="text === 'OK' ? 'green' : 'red'">{{ text }}</a-tag>
                        </template>
                    </a-table>
                </a-card>

                <!-- 검사장치 관리 -->
                <a-card title="검사장치 관리" :bordered="false" style="margin-bottom: 16px;">
                    <a-table 
                        :columns="inspectionViewColumns" 
                        :data-source="viewData.inspection" 
                        :pagination="false"
                        size="small"
                        bordered
                    >
                        <template slot="no" slot-scope="text, record, index">
                            {{ index + 1 }}
                        </template>
                        <template slot="result" slot-scope="text">
                            <a-tag :color="text === 'OK' ? 'green' : 'red'">{{ text }}</a-tag>
                        </template>
                    </a-table>
                </a-card>

                <a-card
                    v-for="section in viewData.gasFilling"
                    :key="section.target"
                    :bordered="false"
                    style="margin-bottom: 16px;"
                >
                    <template slot="title">
                        <span>GAS 충진 M/C ({{ section.target }})</span>
                        <span style="margin-left: 24px; font-weight: normal; font-size: 14px;">
                            S/W 상태
                            <a-tag
                                v-if="section.swStatus"
                                :color="section.swStatus === 'OK' ? 'green' : 'red'"
                                style="margin-left: 8px;"
                            >
                                {{ section.swStatus }}
                            </a-tag>
                            <span v-else style="margin-left: 8px;">-</span>
                        </span>
                    </template>
                    <a-table
                        :data-source="section.rows"
                        :pagination="false"
                        size="small"
                        bordered
                        :row-key="record => `${section.target}-${record.shift}`"
                    >
                        <a-table-column title="구분" data-index="shift" key="shift" width="80" />
                        <a-table-column title="레온 압력" data-index="freonPressure" key="freonPressure" />
                        <a-table-column title="진공도" data-index="vacuumLevel" key="vacuumLevel" />
                        <a-table-column title="프레온 온도" data-index="freonTemperature" key="freonTemperature" />
                        <a-table-column title="셋팅" data-index="settingValue" key="settingValue" />
                        <a-table-column title="충진량" data-index="chargeAmount" key="chargeAmount" />
                        <a-table-column title="점검결과" data-index="checkResult" key="checkResult" width="120">
                            <template slot-scope="text">
                                <a-tag :color="text === 'OK' ? 'green' : (text === 'NG' ? 'red' : 'default')">{{ text || '-' }}</a-tag>
                            </template>
                        </a-table-column>
                    </a-table>
                </a-card>

                <a-divider />
                <div id="print-button-container" style="margin-top:20px; text-align:center;">
                    <a-button type="default" icon="plus-circle" size="default" @click="handlerForCloseDrawer">
                        나가기
                    </a-button>
                    <a-button type="default" icon="plus-circle" size="default" @click="print()" style="margin-left:20px;">
                        인쇄
                    </a-button>
                    <a-button v-if="currentViewState !== 'TL_F'" type="primary" icon="plus-circle" size="default" @click="handlerForApproveFromDrawer(true)" style="margin-left:20px;">
                        승인완료
                    </a-button>
                    <a-button v-if="currentViewState === 'TL_F'" type="danger" icon="plus-circle" size="default" @click="handlerForApproveFromDrawer(false)" style="margin-left:20px;">
                        승인완료 취소
                    </a-button>
                </div>
                </div><!-- /#print -->
            </a-form>
        </a-drawer>
    </div>
</template>

<script>
import DatePicker from 'vue2-datepicker';
import PageHeader from "../components/PageHeader.vue";

const columns = [
    { title: '상태', dataIndex: 'tags', key: 'tags', scopedSlots: { customRender: 'tags' }, width: 100 },
    { title: '라인명', dataIndex: 'lineName', key: 'lineName' },
    { title: '생산모델', dataIndex: 'productModel', key: 'productModel' },
    { title: '작성자', dataIndex: 'writer', key: 'writer' },
    { title: '작성일자', dataIndex: 'date', key: 'date' },
    { title: '최종수정일', dataIndex: 'updated', key: 'updated' },
    { title: '점검결과', dataIndex: 'checkResult', key: 'checkResult', scopedSlots: { customRender: 'checkResult' } },
    { title: '관리', key: 'action', scopedSlots: { customRender: 'action' }, width: 280 },
];

const driverTorqueViewColumnsBase = [
    { title: 'No', key: 'no', scopedSlots: { customRender: 'no' }, width: 50 },
    { title: '공정명', dataIndex: 'processName', key: 'processName' },
    { title: '공구분류', dataIndex: 'toolType', key: 'toolType' },
    { title: '관리번호', dataIndex: 'managementNo', key: 'managementNo' },
    { title: '기준', dataIndex: 'standard', key: 'standard' },
    { title: '측정값', dataIndex: 'measuredValue', key: 'measuredValue' },
    { title: '측정자', dataIndex: 'measuredBy', key: 'measuredBy' },
    { title: '교환번호', dataIndex: 'exchangeNo', key: 'exchangeNo' },
    { title: '결과', key: 'result', dataIndex: 'result', scopedSlots: { customRender: 'result' }, width: 80 },
];

const measurementViewColumnsBase = [
    { title: 'No', key: 'no', scopedSlots: { customRender: 'no' }, width: 50 },
    { title: '분류', dataIndex: 'category', key: 'category' },
    { title: '장비명', dataIndex: 'equipmentName', key: 'equipmentName' },
    { title: '점검항목', dataIndex: 'checkItem', key: 'checkItem' },
    { title: '기준', dataIndex: 'standard', key: 'standard' },
    { title: '단위', dataIndex: 'unit', key: 'unit' },
    { title: '측정값', dataIndex: 'measuredValue', key: 'measuredValue' },
    { title: '결과', key: 'result', dataIndex: 'result', scopedSlots: { customRender: 'result' }, width: 80 },
    { title: '검사자', dataIndex: 'inspector', key: 'inspector' },
    { title: '메모', dataIndex: 'memo', key: 'memo' },
];

const GAS_FILLING_CATEGORY = 'GAS 충진 M/C';
const GAS_FILLING_TARGETS = ['제습기', '정수기'];
const GAS_FILLING_SHIFTS = ['오전', '오후', '잔업'];

const gasSaverViewColumnsBase = [
    { title: 'No', key: 'no', scopedSlots: { customRender: 'no' }, width: 50 },
    { title: '관리번호', dataIndex: 'managementNo', key: 'managementNo' },
    { title: '점검항목', dataIndex: 'checkItem', key: 'checkItem' },
    { title: '기준', dataIndex: 'standard', key: 'standard' },
    { title: '측정값', dataIndex: 'measuredValue', key: 'measuredValue' },
    { title: '결과', key: 'result', dataIndex: 'result', scopedSlots: { customRender: 'result' }, width: 80 },
];

// 헤더가 데이터보다 길어 2줄로 깨지는 컬럼만 최소 너비 보정
const HEADER_MIN_WIDTH_KEYS = ['toolType', 'measuredValue'];

const inspectionViewColumnsBase = [
    { title: 'No', key: 'no', scopedSlots: { customRender: 'no' }, width: 50 },
    { title: '장비명', dataIndex: 'equipmentName', key: 'equipmentName' },
    { title: '점검항목', dataIndex: 'checkItem', key: 'checkItem' },
    { title: '기준', dataIndex: 'standard', key: 'standard' },
    { title: '결과', key: 'result', dataIndex: 'result', scopedSlots: { customRender: 'result' }, width: 80 },
];

export default {
    name: 'ToolWorkReport',
    components: {
        PageHeader,
        DatePicker,
    },
    data() {
        return {
            columns,
            driverTorqueViewColumns: driverTorqueViewColumnsBase.map(c => ({ ...c })),
            measurementViewColumns: measurementViewColumnsBase.map(c => ({ ...c })),
            gasSaverViewColumns: gasSaverViewColumnsBase.map(c => ({ ...c })),
            inspectionViewColumns: inspectionViewColumnsBase.map(c => ({ ...c })),
            data: [],
            filterCS: '',
            filterField: '라인명',
            filterDateStartCS: '',
            filterDateEndCS: '',
            isLoading: false,
            pagination: {
                current: 1,
                pageSize: 10,
                total: 0,
                showSizeChanger: true,
                showTotal: (total, range) => `${range[0]}-${range[1]} / ${total}개`
            },
            flagForDrawer: false,
            currentViewKey: null,
            currentViewState: '',
            viewData: {
                basicInfo: {
                    lineName: '',
                    writer: '',
                    productModel: '',
                    approverName: '',
                    approvalDate: ''
                },
                driverTorque: [],
                gasFilling: [],
                measurement: [],
                gasSaver: [],
                inspection: []
            }
        };
    },
    mounted() {
        this.fetchReportList();
    },
    methods: {
        createGasFillingRows() {
            return GAS_FILLING_SHIFTS.map(shift => ({
                shift,
                freonPressure: '',
                vacuumLevel: '',
                freonTemperature: '',
                settingValue: '',
                chargeAmount: '',
                checkResult: '',
            }));
        },
        ensureGasSection(target) {
            let section = this.viewData.gasFilling.find(item => item.target === target);
            if (!section) {
                section = { target, swStatus: '', rows: this.createGasFillingRows() };
                this.viewData.gasFilling.push(section);
            }
            return section;
        },
        applyGasSectionSwStatus(section, shift, memo, parsedValue) {
            const sw = memo || (parsedValue && parsedValue.swStatus) || '';
            if (!sw) return;
            if (shift === '오전' || !section.swStatus) {
                section.swStatus = sw;
            }
        },
        parseGasMeasuredValue(rawValue) {
            if (!rawValue) return {};
            if (typeof rawValue === 'object') return rawValue;
            try {
                return JSON.parse(rawValue);
            } catch (e) {
                return {};
            }
        },
        loadGasRowFromItem(gasRow, item) {
            const raw = item.measuredValue != null ? String(item.measuredValue).trim() : '';
            if (raw.startsWith('{')) {
                const parsed = this.parseGasMeasuredValue(raw);
                gasRow.freonPressure = parsed.freonPressure || '';
                gasRow.vacuumLevel = parsed.vacuumLevel || '';
                gasRow.freonTemperature = parsed.freonTemperature || '';
                gasRow.settingValue = parsed.settingValue || '';
                gasRow.chargeAmount = parsed.chargeAmount || '';
            } else {
                gasRow.freonPressure = item.measuredValue || '';
                gasRow.vacuumLevel = item.standard || '';
                gasRow.freonTemperature = item.unit || '';
                gasRow.settingValue = item.measuredBy || '';
                gasRow.chargeAmount = item.exchangeNo || '';
            }
            gasRow.checkResult = item.result || '';
        },
        _getTextWidth(text) {
            if (!this.__canvas) {
                this.__canvas = document.createElement('canvas');
                const ctx = this.__canvas.getContext('2d');
                ctx.font = '14px -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif';
                this.__ctx = ctx;
            }
            return this.__ctx.measureText(String(text == null ? '' : text)).width;
        },
        _getHeaderTextWidth(text) {
            if (!this.__headerCtx) {
                const canvas = document.createElement('canvas');
                this.__headerCtx = canvas.getContext('2d');
                this.__headerCtx.font = 'bold 14px -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif';
            }
            return this.__headerCtx.measureText(String(text || '')).width;
        },
        computeColumnWidths(baseCols, dataRows) {
            const cellPadding = 16;
            return baseCols.map(col => {
                const c = { ...col };
                if (c.key === 'no' || c.key === 'result') return c;
                if (!c.dataIndex) return c;

                let maxW = 0;
                dataRows.forEach(row => {
                    const w = this._getTextWidth(row[c.dataIndex]);
                    if (w > maxW) maxW = w;
                });

                if (c.key === 'memo' && maxW === 0) {
                    delete c.width;
                    return c;
                }

                let width = maxW > 0 ? Math.ceil(maxW + cellPadding * 2) : 0;

                if (HEADER_MIN_WIDTH_KEYS.includes(c.key) && c.title) {
                    const headerMin = Math.ceil(this._getHeaderTextWidth(c.title) + cellPadding * 2);
                    if (width < headerMin) width = headerMin;
                }

                if (!width) {
                    delete c.width;
                    return c;
                }

                c.width = width;
                return c;
            });
        },
        recomputeAllColumnWidths() {
            this.driverTorqueViewColumns = this.computeColumnWidths(
                driverTorqueViewColumnsBase, this.viewData.driverTorque
            );
            this.measurementViewColumns = this.computeColumnWidths(
                measurementViewColumnsBase, this.viewData.measurement
            );
            this.gasSaverViewColumns = this.computeColumnWidths(
                gasSaverViewColumnsBase, this.viewData.gasSaver
            );
            this.inspectionViewColumns = this.computeColumnWidths(
                inspectionViewColumnsBase, this.viewData.inspection
            );
        },
        fetchReportList() {
            this.isLoading = true;
            const page = this.pagination.current - 1;
            const size = this.pagination.pageSize;
            let url = `${this.$store.state.nodeApiUrl}/tool/report/list?size=${size}&page=${page}`;
            
            if (this.filterDateStartCS) {
                url += `&start_date=${this.filterDateStartCS}`;
            }
            if (this.filterDateEndCS) {
                url += `&end_date=${this.filterDateEndCS}`;
            }
            
            this.$http.get(url)
                .then((response) => {
                    if (response.status === 200 && response.data.code === 'success') {
                        this.pagination.total = response.data.data.totalElements || 0;
                        this.data = response.data.data.content.map(item => ({
                            key: item.productCsSeq,
                            tags: [item.state === 'TL_D' ? '작성완료' : '승인완료'],
                            lineName: item.line,
                            productModel: item.productModel || '-',
                            writer: item.manager,
                            date: item.updated ? item.updated.split(' ')[0] : '',
                            updated: item.updated,
                            checkResult: item.checkResult || 'OK'
                        }));
                    }
                    this.isLoading = false;
                })
                .catch((error) => {
                    console.error(error);
                    this.$message.error('목록 조회에 실패했습니다.');
                    this.isLoading = false;
                });
        },
        filterCSList() {
            console.log('Filter:', this.filterField, this.filterCS);
            this.fetchReportList();
        },
        resetCSList() {
            this.filterCS = '';
            this.filterDateStartCS = '';
            this.filterDateEndCS = '';
            this.fetchReportList();
        },
        handleTableChange(pagination) {
            this.pagination.current = pagination.current;
            this.pagination.pageSize = pagination.pageSize;
            this.fetchReportList();
        },
        handlerToView(key) {
            const listItem = this.data.find(d => d.key === key);
            this.currentViewKey = key;
            this.currentViewState = listItem ? (listItem.tags[0] === '승인완료' ? 'TL_F' : 'TL_D') : 'TL_D';

            this.$http.get(`${this.$store.state.nodeApiUrl}/tool/template/item/${key}`)
                .then((response) => {
                    if (response.status === 200 && response.data.code === 'success') {
                        const data = response.data.data;
                        const isApproved = data.state === 'TL_F' || this.currentViewState === 'TL_F';
                        this.viewData.basicInfo.lineName = data.line;
                        this.viewData.basicInfo.writer = data.manager;
                        this.viewData.basicInfo.productModel = data.productModel || '';
                        this.viewData.basicInfo.approverName = isApproved
                            ? (data.approver || data.updater || '')
                            : '';
                        this.viewData.basicInfo.approvalDate = isApproved ? (data.updated || '') : '';
                        
                        this.viewData.driverTorque = [];
                        this.viewData.gasFilling = [];
                        this.viewData.measurement = [];
                        this.viewData.gasSaver = [];
                        this.viewData.inspection = [];
                        
                        data.items.forEach(item => {
                            if (item.category === 'driver_torque') {
                                this.viewData.driverTorque.push({
                                    processName: item.processName,
                                    toolType: item.toolType,
                                    managementNo: item.managementNo,
                                    standard: item.standard,
                                    measuredValue: item.measuredValue,
                                    measuredBy: item.measuredBy,
                                    exchangeNo: item.exchangeNo,
                                    result: item.result
                                });
                            } else if (item.category === 'measurement') {
                                if (
                                    item.categoryName === GAS_FILLING_CATEGORY &&
                                    GAS_FILLING_TARGETS.includes(item.equipmentName)
                                ) {
                                    const section = this.ensureGasSection(item.equipmentName);
                                    const gasRow = section.rows.find(row => row.shift === item.checkItem);
                                    if (gasRow) {
                                        this.loadGasRowFromItem(gasRow, item);
                                        this.applyGasSectionSwStatus(
                                            section,
                                            item.checkItem,
                                            item.memo,
                                            null
                                        );
                                    }
                                    return;
                                }
                                this.viewData.measurement.push({
                                    category: item.categoryName,
                                    equipmentName: item.equipmentName,
                                    checkItem: item.checkItem,
                                    standard: item.standard,
                                    unit: item.unit,
                                    measuredValue: item.measuredValue,
                                    result: item.result,
                                    inspector: item.inspector,
                                    memo: item.memo
                                });
                            } else if (item.category === 'gas_saver') {
                                this.viewData.gasSaver.push({
                                    managementNo: item.managementNo,
                                    checkItem: item.checkItem,
                                    standard: item.standard,
                                    measuredValue: item.measuredValue,
                                    result: item.result
                                });
                            } else if (item.category === 'inspection') {
                                this.viewData.inspection.push({
                                    equipmentName: item.equipmentName,
                                    checkItem: item.checkItem,
                                    standard: item.standard,
                                    result: item.result
                                });
                            }
                        });
                        
                        this.flagForDrawer = true;
                        this.$nextTick(() => {
                            this.recomputeAllColumnWidths();
                        });
                    }
                })
                .catch((error) => {
                    console.error(error);
                    this.$message.error('데이터 조회에 실패했습니다.');
                });
        },
        handlerToApprove(key) {
            this.$confirm({
                title: '승인 확인',
                content: '해당 일지를 승인하시겠습니까?',
                onOk: () => {
                    this.$http.put(`${this.$store.state.nodeApiUrl}/tool/report/state/${key}`, {
                        state: 'TL_F',
                        approver: sessionStorage.getItem('user_name') || ''
                    })
                        .then((response) => {
                            if (response.status === 200 && response.data.code === 'success') {
                                this.$message.success('승인되었습니다.');
                                this.fetchReportList();
                            }
                        })
                        .catch((error) => {
                            console.error(error);
                            this.$message.error('승인에 실패했습니다.');
                        });
                }
            });
        },
        handlerToCancelApprove(key) {
            this.$confirm({
                title: '승인취소 확인',
                content: '승인을 취소하시겠습니까?',
                onOk: () => {
                    this.$http.put(`${this.$store.state.nodeApiUrl}/tool/report/state/${key}`, { state: 'TL_D', approver: '' })
                        .then((response) => {
                            if (response.status === 200 && response.data.code === 'success') {
                                this.$message.success('승인이 취소되었습니다.');
                                this.fetchReportList();
                            }
                        })
                        .catch((error) => {
                            console.error(error);
                            this.$message.error('승인취소에 실패했습니다.');
                        });
                }
            });
        },
        handlerToDelete(key) {
            this.$confirm({
                title: '삭제 확인',
                content: '정말 삭제하시겠습니까?',
                onOk: () => {
                    this.$http.delete(`${this.$store.state.nodeApiUrl}/tool/template/delete/${key}`)
                        .then((response) => {
                            if (response.status === 200 && response.data.code === 'success') {
                                this.$message.success('삭제되었습니다.');
                                this.fetchReportList();
                            }
                        })
                        .catch((error) => {
                            console.error(error);
                            this.$message.error('삭제에 실패했습니다.');
                        });
                }
            });
        },
        handlerForCloseDrawer() {
            this.flagForDrawer = false;
        },
        print() {
            const prtHtml = document.getElementById('print').innerHTML;

            let stylesHtml = '';
            for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
                stylesHtml += node.outerHTML;
            }

            const WinPrint = window.open('', '', 'left=0,top=0,width=1600,height=900,toolbar=0,scrollbars=0,status=0');

            WinPrint.document.write(`<!DOCTYPE html>
            <html>
            <head>
                ${stylesHtml}
            </head>
            <body>
                ${prtHtml}
            </body>
            </html>`);

            WinPrint.document.close();
            WinPrint.focus();
            WinPrint.onload = function() {
                setTimeout(function() {
                    WinPrint.print();
                    WinPrint.close();
                }, 1000);
            };
        },
        handlerForApproveFromDrawer(approve) {
            const newState = approve ? 'TL_F' : 'TL_D';
            const lineName = this.viewData.basicInfo.lineName || '';
            const model = this.viewData.basicInfo.productModel || '';
            const message = approve
                ? `${lineName} ${model} 보고서를 승인하시겠습니까?`
                : `${lineName} ${model} 보고서를 승인취소하시겠습니까?`;

            if (confirm(message)) {
                this.$http.put(`${this.$store.state.nodeApiUrl}/tool/report/state/${this.currentViewKey}`, {
                    state: newState,
                    approver: approve ? (sessionStorage.getItem('user_name') || '') : ''
                })
                    .then((response) => {
                        if (response.status === 200 && response.data.code === 'success') {
                            this.$message.success(approve ? '승인되었습니다.' : '승인이 취소되었습니다.');
                            if (approve) {
                                const approverName = sessionStorage.getItem('user_name') || '';
                                this.currentViewState = 'TL_F';
                                this.viewData.basicInfo.approverName = approverName;
                                this.viewData.basicInfo.approvalDate = this.getCurrentDateTime();
                            } else {
                                this.currentViewState = 'TL_D';
                                this.viewData.basicInfo.approverName = '';
                                this.viewData.basicInfo.approvalDate = '';
                            }
                            this.flagForDrawer = false;
                            this.fetchReportList();
                        }
                    })
                    .catch((error) => {
                        console.error(error);
                        this.$message.error(approve ? '승인에 실패했습니다.' : '승인취소에 실패했습니다.');
                    });
            }
        },
        getCurrentDateTime() {
            const now = new Date();
            const pad = n => String(n).padStart(2, '0');
            return `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())} ${pad(now.getHours())}:${pad(now.getMinutes())}:${pad(now.getSeconds())}`;
        },
    }
};
</script>

<style scoped>
.state-btn {
    font-weight: bold;
    padding: 2px 8px;
}
.state-btn.green {
    background-color: #52c41a;
    color: white;
}
.state-btn.navy {
    background-color: #1890ff;
    color: white;
}
</style>
